var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDocDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.875 13.0625L13.0796 12.2671L11.625 13.7218V9.125H10.5V13.7218L9.04537 12.2671L8.25 13.0625L11.0625 15.875L13.875 13.0625Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.125 14.75H1.5V1.25001H6V4.62501C6.00086 4.92311 6.11966 5.20876 6.33046 5.41955C6.54125 5.63035 6.8269 5.74915 7.125 5.75001H10.5V7.43751H11.625V4.62501C11.627 4.55108 11.613 4.47759 11.5838 4.40961C11.5547 4.34164 11.5112 4.28079 11.4563 4.23126L7.51875 0.29376C7.46924 0.23882 7.40839 0.19528 7.34041 0.166145C7.27243 0.137011 7.19893 0.122976 7.125 0.12501H1.5C1.2019 0.125871 0.916248 0.244674 0.705456 0.455466C0.494664 0.666258 0.375861 0.951906 0.375 1.25001V14.75C0.375861 15.0481 0.494664 15.3338 0.705456 15.5446C0.916248 15.7553 1.2019 15.8741 1.5 15.875H7.125V14.75ZM7.125 1.47501L10.275 4.62501H7.125V1.47501Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocDownload);
export default __webpack_public_path__ + "static/media/doc_download.f8604781fb82c54e80b6505d5608f58d.svg";
export { ForwardRef as ReactComponent };